import { useEffect, Suspense, lazy } from 'react';
import { useAuth } from './hooks/useAuth';
import LandingPage from './components/LandingPage';
import { initializeAnalytics, logPageView } from './lib/firebase/analytics';
import './App.css';

// Lazy load Dashboard component since it's only needed for authenticated users
const Dashboard = lazy(() => import('./components/Dashboard'));

function App() {
  const { user, loading, error } = useAuth();

  // Initialize analytics when app loads
  useEffect(() => {
    initializeAnalytics();
    logPageView('app_home');
  }, []);

  if (loading) {
    return (
      <div className="app-loading">
        <div className="loading-spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="app-loading">
        <div style={{ color: 'red', textAlign: 'center', padding: '20px' }}>
          <h2>Error</h2>
          <p>{error}</p>
          <p>Check console for more details</p>
        </div>
      </div>
    );
  }

  // If user is authenticated, show dashboard
  if (user) {
    return (
      <div className="app">
        <Suspense fallback={
          <div className="app-loading">
            <div className="loading-spinner"></div>
            <p>Loading Dashboard...</p>
          </div>
        }>
          <Dashboard />
        </Suspense>
      </div>
    );
  }

  // If user is not authenticated, show landing page with integrated auth
  return (
    <div className="app">
      <LandingPage onGetStarted={() => {/* Handle getting started */}} />
    </div>
  );
}

export default App;
